import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumUserAccounts as LogoPersons } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/settings/persons/_list')({
  component: Persons
});
function Persons() {
  const {
    t
  } = useTranslation();
  const tabs = [{
    to: '/settings/persons/staff',
    // NOTE" バックエンド上はoperatorという名前で管理されている
    children: t('common.list.persons.operator')
  }, {
    to: '/settings/persons/individual',
    children: t('common.list.persons.individual')
  }, {
    to: '/settings/persons/settings',
    children: t('common.list.persons.settings')
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col">
      {/*
        sticky を切っている理由: 設定タブのサイドバーが sticky で追従する際、
        sticky なヘッダー（z-10）の背後に潜ってしまう。ヘッダー高さは内容で変わるため
        オフセットを固定値で置けず、ヘッダー側を流す方を選んだ。
       */}
      <ProductHeader Logo={LogoPersons} name={t('pages.settings.persons.title')} tabs={tabs} type="resource" sticky={false} />
      <Outlet />
    </div>;
}